import { Box } from '@mui/material';
import { App, Form, Spin } from 'antd';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import MainCard from 'components/MainCard';
import { toastConfig } from 'config';
import { isEqual } from 'lodash';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetSingleIdentityMutation } from 'store/features/process/processApi';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

import CardAccordion from './CustomComponents/CardAccordion';
import LeaseDetailsShowAll from './CustomComponents/LeaseDetailsShowAll';
import { constantFormValues } from './root';
import IdentityCaseActivityModal from 'pages/IdentityCase/IdentityCaseActivityModal';
import ActionButtons from './CustomComponents/cardSections/ActionButtons';
import { hasGlKey, isGrossRentLessThanAdvanceOnEachItem, isSequential, stateUpdater, utcConverter } from './CustomComponents/LeaseUtils/helper';
import AgreementFiles from './CustomComponents/cardSections/AgreementFiles';
import LeaseBulkUpload from './CustomComponents/LeaseBulkUpload2';
import GeneralLeaseInformation from './CustomComponents/cardSections/GeneralLeaseInformation';
import FinancialTermsConditions from './CustomComponents/cardSections/FinancialTermsConditions';
import IFRS16FieldsModifications from './CustomComponents/cardSections/IFRS16FieldsModifications';
import AccountingInformation from './CustomComponents/cardSections/AccountingInformation';
import LeasePageHeader from 'components/header/LeasePageHeader';
import LeaseHistory from './CustomComponents/LeaseUtils/History/LeaseHistory';
import LeaseSchedule from './CustomComponents/cardSections/LeaseSchedule';
import { useGetQueryV3DeltaQuery } from 'store/features/api/graphSlice';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';

// Cache to store lease data for quick access
const leaseDataCache = {};

dayjs.extend(utc);

const Create = ({ screen = 'CREATE' }) => {
	const { message: messageApi } = App.useApp();
	//constants
	dayjs.extend(utc);
	// Get cache key before component initializes
	const { state } = useLocation();
	const [tabInstanceId] = useState(() => `tab_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);
	const cacheKey = screen?.toLowerCase() === 'view' ? `${state?._id}-${state?.processCode}` : null;
	const initialCachedData = cacheKey ? leaseDataCache[cacheKey] : null;
	// const [IdentityBulk] = useIdentityBulkMutation();
	const [form] = Form.useForm();
	// const identityData = form.getFieldsValue();
	const actionButtonsRef = useRef();
	const leaseScheduleRef = useRef();
	const leaseDetailsShowAllRef = useRef();

	// const [previousFormData, setPreviousFormData] = useState({});
	const navigate = useNavigate();
	// const [searchParams] = useSearchParams();
	const [selectedTab, setSelectedTab] = useState(0);
	// Combined States
	const [formState, setFormState] = useState({
		showActiveDeactiveModal: false,
		showFormSubmitModal: false,
		submitPayload: null,
		modalData: {
			head: state?.processName ?? '',
			label: 'Do you want to proceed?',
		},
	});
	// Initialize dataFullyLoaded as true if we have cached data
	const [dataFullyLoaded, setDataFullyLoaded] = useState(!!initialCachedData);
	//simplified state setter
	const updateFormState = stateUpdater(setFormState);

	const { lynFormProperties, isLoading } = useControlData();

	//Single States
	const [rowIndex, setRowIndex] = useState(0);

	const setShowFormSubmitModal = (value) => {
		updateFormState('showFormSubmitModal', value);
	};

	const [creationApi, { isLoading: isCreatLoading, error: createError, isSuccess: isCreateSuccess, isError: isCreateError }] =
		useGetSingleIdentityMutation();

	// view Screen specific
	// Initialize with cached data if available
	const [cachedLeaseData, setCachedLeaseData] = useState(initialCachedData);

	const [
		getSingleLeaseData,
		{
			data: singleLeaseData, //viewData
			isLoading: isViewLoading,
		},
	] = useGetSingleIdentityMutation();

	// Use either cached data or API data
	const displayLeaseData = cachedLeaseData || singleLeaseData;
	// console.log(displayLeaseData, 'displayLeaseData');
	const { profileData } = useSelector((state) => state?.profile);
	// console.log(displayLeaseData, 'displayLeaseData');
	// if () {}
	const statusData = useMemo(() => {
		return screen?.toLowerCase() === 'view'
			? !(
					displayLeaseData?.activationStatus === 'W-I-P' &&
					displayLeaseData?.recordStatus === 'parked' &&
					profileData?.userId === displayLeaseData?.approverUserId[0]
				)
				? displayLeaseData?.data
				: displayLeaseData?.parkedData
			: [];
	}, [displayLeaseData, screen]);
	const hasGlAssigned = hasGlKey(statusData);
	const hasCCAssigned = Boolean(statusData?.refCCAssignmentIdentityId);
	// console.log(statusData, 'statusData');
	// const [
	// 	getAccountingAssignment,
	// 	// {
	// 	// 	data: accountingAssignmentData,
	// 	// 	// isLoading: isAccountingAssignmentLoading
	// 	// },
	// ] = useSendControlDataMutation();
	// const setAccountingAssignmentData = async (payload) => {
	// 	await getAccountingAssignment(payload).then((res) => {
	// 		form.setFieldsValue({
	// 			...formatAccountingAssignmentData(res?.data?.responseData),
	// 		});
	// 	});
	// };
	// useEffect(() => {
	// 	if (screen?.toLowerCase() === 'view') {
	// 		const payload = {
	// 			data: identityData?.identityId,
	// 			processCode: state?.processCode,
	// 			scriptName: 'lease-controller-accounts',
	// 		};
	// 		setAccountingAssignmentData(payload);
	// 	}
	// }, [identityData?.identityId]);
	useEffect(() => {
		if (screen?.toLowerCase() === 'create') {
			form.resetFields();

			setTimeout(() => {
				if (initialFormValues && form) {
					form.setFieldsValue(initialFormValues);
					// For create mode, we need to set dataFullyLoaded to true after form initialization
					setDataFullyLoaded(true);
				}
			}, 0);
		}
		if (screen?.toLowerCase() === 'view') {
			// If we already have the cache key and cached data, no need to recalculate
			// We've already set the initial state with cached data
			if (!initialCachedData) {
				// If no cached data, fetch it
				const fetchLeaseData = async () => {
					try {
						const response = await getSingleLeaseData({
							suffixCode: '',
							_id: state?._id ?? '',
							operation: 'get-single',
							processCode: state?.processCode,
						}).unwrap();

						// Store in cache for future use
						leaseDataCache[cacheKey] = response;
						// No need to check for differences since we don't have initial cached data
						setCachedLeaseData(response);
					} catch (error) {
						console.error('Error fetching lease data:', error);
					}
				};
				fetchLeaseData();
			} else {
				// If we have cached data, still fetch in background to check for updates
				// But don't show any loading state
				const fetchInBackground = async () => {
					try {
						const response = await getSingleLeaseData({
							suffixCode: '',
							_id: state?._id ?? '',
							operation: 'get-single',
							processCode: state?.processCode,
						}).unwrap();

						// Only update if the data is actually different
						if (!isEqual(initialCachedData, response)) {
							leaseDataCache[cacheKey] = response;
							setCachedLeaseData(response);
						}
					} catch (error) {
						// Silent fail for background fetch
					}
				};
				// Use requestAnimationFrame to defer the background fetch until after rendering
				requestAnimationFrame(() => {
					fetchInBackground();
				});
			}
		}
	}, [screen, initialCachedData, state?._id, state?.processCode, cacheKey]);
	useEffect(() => {
		if (screen === 'CREATE') {
			if (isCreateSuccess) {
				toast.success('Success! Action completed ', toastConfig);
				navigate(-1);
			}
			if (isCreateError) {
				if (createError?.data?.code === '501') {
					toast.error(createError?.data?.message, toastConfig);
				} else {
					toast.error('Failed! Action not completed', toastConfig);
				}
			}
		}
	}, [isCreateSuccess, createError, isCreateError, screen]);

	//constants

	const initialFormValues = useMemo(
		() => ({
			tabIndex: '1',
			version: '',
			leaseId: '',
			leaseTitle: '',
			leaseType: 'Finance Lease',
			lessorName: '',
			lessorID: null,
			leaseTerm: '',
			leaseEndDate: '',
			creationDate: dayjs(),
			lastModifiedDate: dayjs(),
			escalationPercentage: '0',
			inputChangeMonth: '1',
			grossRentList: [
				{
					from: 1,
					to: '',
					amount: '',
					remarks: '',
				},
			],
			grossRentListSet: [[]],
			advanceAmountListSet: [[]],

			advanceAmountList: [
				{
					from: 1,
					to: '',
					amount: '',
					totalAmount: '',
				},
			],
			advanceAmount: '0',
			advanceDuration: '0',
			upfrontLeasePayment: '',
			initialDirectCost: '',
			securityDeposit: '',
			initialDiscountRate: '0',
			// rightOfUseAssetValue: '10000250 - RoU Front Offices',
			// glleaseLiability: '20001120 - Lease Liabilities',
			// costCenterInterestExpense: '902001 - Finance Common',
			// glInterestExpense: '40004250 - Interest for Lease',
			// leasePayableControlAccount: '20001100 - Lease Payable',
			// glAdvanceRent: '10002050 - Advance Rent',
			// depreciationRoUCostCenter: '902003 - Finance Common',
			// depreciationRoU: '20007555 - Depreciation RoU',
			// accumDepreciationRoU: '20004255 - Accum Depreciation RoU',
			// glBankAccount: '10003001 - SCB Main',
			// leaseExpense: '40004260 - Interest for Lease',
			// leaseExpenseCostCenter: '902002 - Finance Common',
			// securityDepositHead: '10009008 - Security Deposite',
			// accountsPayableHead: '20003300 - Accounts Payable',
			identityId: '',
			cashIncentiveAmount: '',

			paymentModality: 'Start',
			paymentFrequency: 'Monthly',
			endOfFinancialYear: utcConverter(dayjs().month(11).date(31)),
			changes: [
				{
					inputChangeEffectiveDate: '',
					inputChangeAdvance: '',
					inputChangeAdvanceAmounts: [],
					inputChangeDescription: 'Initial Rent',
					inputChangeDiscountRate: 0,
					inputChangeEscalation: 0,
					inputChangeGrossAmount: 0,
					inputChangeGrossRents: [],
					inputChangeLeaseTerm: '',
					paymentFrequency: 'Monthly',
					paymentTime: 'Start',
				},
			],
			agreementFiles: [
				{
					id: '',
					name: '',
					file: '',
				},
			],
		}),
		[]
	);

	//states

	// Redux selectors
	// const { creatorOrganizationId, userId } = useSelector((state) => state.profile.profileData);
	// const companyCode = creatorOrganizationId;

	useEffect(() => {
		if (screen?.toLowerCase() === 'view' && statusData) {
			// let modifiedLeaseTerm;
			// if (statusData?.paymentFrequency === 'Monthly') {
			// 	modifiedLeaseTerm = statusData?.leaseTerm;
			// } else if (statusData?.paymentFrequency === 'Quarterly') {
			// 	modifiedLeaseTerm = statusData?.leaseTerm / 3;
			// }
			const viewValues = {
				// General Lease Information section
				tabIndex: '1',
				modificationSequence: statusData?.modificationSequence,
				leaseId: statusData?.leaseId,
				leaseType: statusData?.leaseType,
				leaseTitle: statusData?.leaseTitle,
				lessorName: statusData?.lessorName,
				lessorID: statusData?.lessorID,
				paymentFrequency: statusData?.paymentFrequency,
				paymentModality: statusData?.paymentModality,
				creationDate: dayjs(statusData?.creationDateTime?.localDateTimeStringAMPM) ?? null,
				lastModifiedDate: dayjs(statusData?.lastModifiedDate),

				// Financial Terms & Conditions section
				advanceAmount: statusData?.advanceAmount,
				advanceDuration: statusData?.advanceDuration,
				grossRent: statusData?.grossRent,
				leaseTerm: statusData?.leaseTerm,
				leaseStartDate: dayjs(statusData?.leaseStartDate),
				leaseEndDate: dayjs(statusData?.leaseEndDate),
				escalationPercentage: statusData?.escalationPercentage,
				initialDiscountRate: statusData?.initialDiscountRate,
				upfrontLeasePayment: statusData?.upfrontLeasePayment ?? 0,
				initialDirectCost: statusData?.initialDirectCost ?? 0,
				securityDeposit: statusData?.securityDeposit ?? 0,
				endOfFinancialYear: utcConverter(dayjs().month(11).date(31)),
				// Accounting Information section
				rightOfUseAssetValue: statusData?.rightOfUseAssetValue,
				glleaseLiability: statusData?.glleaseLiability ?? '',
				costCenterInterestExpense: statusData?.costCenterInterestExpense,
				glInterestExpense: statusData?.glInterestExpense,
				leaseExpenseCostCenter: statusData?.leaseExpenseCostCenter,
				leaseExpense: statusData?.leaseExpense,
				leasePayableControlAccount: statusData?.leasePayableControlAccount,
				glAdvanceRent: statusData?.glAdvanceRent,
				depreciationRoUCostCenter: statusData?.depreciationRoUCostCenter,
				depreciationROU: statusData?.depreciationRoU,
				accumDepreciationROU: statusData?.accumDepreciationRoU,
				glBankAccount: statusData?.glBankAccount,
				securityDepositHead: statusData?.securityDepositHead,
				accountsPayableHead: statusData?.accountsPayableHead,
				effectiveDateHistory: statusData?.effectiveDateHistory,
				cashIncentiveAmount: statusData?.cashIncentiveAmount || statusData?.cashIncentive,
				//others
				version: String(displayLeaseData?.version),
				leaseLiability: statusData?.leaseLiability,
				amortizationSchedule: statusData?.amortizationSchedule,
				leaseCategory: statusData?.leaseCategory,
				leaseName: statusData?.leaseName,
				contactDetails: statusData?.contactDetails,
				identityId: displayLeaseData?._id,

				renewalOptions: statusData?.renewalOptions,
				terminationOption: statusData?.terminationOption,
				month: statusData?.month,
				refundability: statusData?.refundability,
				agreementFiles: statusData?.agreementFiles,

				responsibility: statusData?.responsibility,
				basisOfRate: statusData?.basisOfRate,
				nonLeaseComponents: statusData?.nonLeaseComponents,
				separateServiceCharges: statusData?.separateServiceCharges,
				modificationDetails: statusData?.modificationDetails,
				discountRateChanges: statusData?.discountRateChanges,
				advanceAmounts: statusData?.advanceAmounts,
				grossRents: statusData?.grossRents,
				grossRentList: statusData?.grossRentList,
				grossRentListSet: statusData?.grossRentListSet,
				advanceAmountListSet: statusData?.advanceAmountListSet,
				advanceAmountList: statusData?.advanceAmountList,

				//changes
				changes: statusData?.changes?.map((item) => {
					const { inputChangeEffectiveDate, ...change } = item;
					return {
						...change,
						inputChangeEffectiveDate: dayjs(inputChangeEffectiveDate),
					};
				}),
			};
			// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ changes:statusData?.changes?.map ~ statusData:', statusData);

			setRowIndex(statusData?.changes?.length);

			// Set form values synchronously for immediate display
			form.setFieldsValue(viewValues);

			// Always set dataFullyLoaded to true after form is populated
			// Use requestAnimationFrame to ensure it happens after render
			requestAnimationFrame(() => {
				// console.log('Setting dataFullyLoaded to true for view mode');
				setDataFullyLoaded(true);
			});
		}
	}, [screen, statusData, displayLeaseData]);
	// const [calculateData, setCalculateData] = useState({});

	const [selectHistory, setSelectHistory] = useState(null);

	const handleSubmit = async () => {
		try {
			// await form.validateFields();
			const formData = form.getFieldsValue();
			// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ handleSubmit ~ formData:', formData);

			if (formData?.paymentFrequency === 'Quarterly' && formData?.leaseTerm % 3 !== 0) {
				messageApi.error(
					"Total lease months must be a multiple of 3 for quarterly payments. Please correct the Lease Payment Schedule's To Month field"
				);
				return;
			}
			if (!isSequential(formData?.grossRentList)) {
				messageApi.error('Gross Rent List must be sequential');
				return;
			}
			if (!isSequential(formData?.advanceAmountList)) {
				messageApi.error('Advance Amount List must be sequential');
				return;
			}
			let grossRentListSet = [];
			let advanceAmountListSet = [];
			let effectiveDateHistory = [];
			grossRentListSet?.push(formData?.grossRentList);
			// console.log(grossRentListSet, 'formData gr');

			advanceAmountListSet?.push(formData?.advanceAmountList);
			effectiveDateHistory?.push(utcConverter(formData?.leaseStartDate));

			const isGrossRentAndAdvanceAmountValid = isGrossRentLessThanAdvanceOnEachItem(formData?.grossRents, formData?.advanceAmounts);
			if (!isGrossRentAndAdvanceAmountValid) {
				messageApi.error('Inconsistency between Lease Payment and Advance Adjustment');
				return;
			}
			const createPagePayload = {
				modificationSequence: 0,
				leaseStartDate: utcConverter(formData?.leaseStartDate),
				leaseTitle: formData?.leaseTitle,
				lessorName: formData?.lessorName,
				lessorID: formData?.lessorID,
				leaseTerm: formData?.leaseTerm,
				leaseEndDate: utcConverter(formData?.leaseEndDate),
				paymentModality: formData?.paymentModality,
				leaseType: formData?.leaseType,
				initialDiscountRate: formData?.initialDiscountRate,
				grossRentList: formData?.grossRentList,
				paymentFrequency: formData?.paymentFrequency,
				advanceAmountList: formData?.advanceAmountList,
				advanceAmount: formData?.advanceAmount,
				advanceAmounts: formData?.advanceAmounts,
				upfrontLeasePayment: formData?.upfrontLeasePayment ?? 0,
				initialDirectCost: formData?.initialDirectCost ?? 0,
				securityDeposit: formData?.securityDeposit ?? 0,
				grossRents: formData?.grossRents,
				cashIncentiveAmount: formData?.cashIncentiveAmount ?? 0,
				grossRent: 0,
				escalationPercentage: 0,
				grossRentListSet,
				advanceAmountListSet,
				effectiveDateHistory,
				modifyCount: 0,
				editCount: 0,
				changes: [
					{
						paymentFrequency: formData?.changes?.[0]?.paymentFrequency,
						paymentTime: formData?.changes?.[0]?.paymentTime,
						inputChangeLeaseTerm: formData?.changes?.[0]?.inputChangeLeaseTerm,
						inputChangeGrossAmount: formData?.changes?.[0]?.inputChangeGrossAmount ?? 0,
						inputChangeDiscountRate: formData?.changes?.[0]?.inputChangeDiscountRate,
						inputChangeEscalation: formData?.changes?.[0]?.inputChangeEscalation ?? 0,
						inputChangeAdvance: formData?.changes?.[0]?.inputChangeAdvance,
						inputChangeEffectiveDate: formData?.changes?.[0]?.inputChangeEffectiveDate,
						inputChangeAdvanceAmounts: formData?.advanceAmounts,
						inputChangeGrossRents: formData?.grossRents,
						inputChangeDescription: formData?.changes?.[0]?.inputChangeDescription,
						upfrontLeasePayment: formData?.upfrontLeasePayment ?? 0,
						initialDirectCost: formData?.initialDirectCost ?? 0,
						securityDeposit: formData?.securityDeposit ?? 0,
						cashIncentiveAmount: formData?.cashIncentiveAmount ?? 0,
					},
				],
				modifiedDateTime: utcConverter(dayjs()),
				paymentModalityLabel: constantFormValues?.paymentModality?.options?.find((item) => item.value === formData?.paymentModality)?.label,

				lastModifiedDate: utcConverter(dayjs()),

				// grossRentListSet,
				// advanceAmountListSet,
				advanceDuration: formData?.advanceAmounts?.filter((item) => item !== 0).length,
			};
			updateFormState('showFormSubmitModal', true);
			updateFormState('modalData.head', 'Confirmation');
			updateFormState('modalData.label', 'Do you want to create?');

			updateFormState('submitPayload', createPagePayload);
		} catch (error) {
			console.error('Validation Failed:', error);
			toast.error('Please fill all required fields', toastConfig);
		}
	};
	useEffect(() => {
		if (displayLeaseData && displayLeaseData.activationStatus !== undefined) {
			window.leaseActivationStatus = displayLeaseData.activationStatus;
		}
	}, [displayLeaseData]);
	const handleModalSubmit = async () => {
		await creationApi({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: formState?.submitPayload,
		});
	};
	// const modalSubmitHandler = () => {
	// 	if (formState?.modalData?.action === 'Active') {
	// 		const payload = {
	// 			_id: activeDeactiveSubmitData.map((item) => item._id),
	// 			operation: 'activate-bulk',
	// 			processCode: state?.processCode,
	// 			activationStatus: 'Active',
	// 		};
	//
	// 		IdentityBulk(payload);
	// 	} else if (formState?.modalData?.action === 'Inactive') {
	// 		const payload = {
	// 			_id: activeDeactiveSubmitData.map((item) => item._id),
	// 			operation: 'activate-bulk',
	// 			processCode: state?.processCode,
	// 			activationStatus: 'Inactive',
	// 		};
	//
	// 		IdentityBulk(payload);
	// 	} else if (formState?.modalData?.action === 'Closed') {
	// 		const payload = {
	// 			_id: activeDeactiveSubmitData.map((item) => item._id),
	// 			operation: 'activate-bulk',
	// 			processCode: state?.processCode,
	// 			activationStatus: 'Closed',
	// 		};
	//
	// 		IdentityBulk(payload);
	// 	} else if (formState?.modalData?.action === 'Reopened') {
	// 		const payload = {
	// 			_id: activeDeactiveSubmitData.map((item) => item._id),
	// 			operation: 'activate-bulk',
	// 			processCode: state?.processCode,
	// 			activationStatus: 'Reopened',
	// 		};
	//
	// 		IdentityBulk(payload);
	// 	} else if (formState?.modalData?.action === 'Delete') {
	// 		const payload = {
	// 			_id: activeDeactiveSubmitData.map((item) => item._id),
	// 			operation: 'delete-bulk',
	// 			processCode: state?.processCode,
	// 		};
	//
	// 		IdentityBulk(payload);
	// 	} else if (formState?.modalData?.action === 'Approve') {
	// 		IdentityBulk({
	// 			_id: activeDeactiveSubmitData,
	// 			operation: 'approve-bulk',
	// 			processCode: state?.processCode,
	// 			suffixCode: '',
	// 		});
	// 	} else if (formState?.modalData?.action === 'Reject') {
	// 		IdentityBulk({
	// 			_id: activeDeactiveSubmitData,
	// 			operation: 'reject-bulk',
	// 			processCode: state?.processCode,
	// 		});
	// 	}
	// 	// Hide the confirmation modal
	// 	setShowActiveDeactiveModal(false);
	// 	// navigate('/static/case-identity', {
	// 	// 	state: state,
	// 	// });
	// };
	// MUI Tab handler
	const selectTabHandler = (event, newValue) => {
		if (isCreatLoading) return;
		setSelectedTab(newValue);
		if (newValue === 1 && dataFullyLoaded && screen?.toLowerCase() !== 'create') {
			if (leaseScheduleRef.current?.queryV3Loader) {
				leaseScheduleRef.current.queryV3Loader();
			}
		}

		if (newValue === 4 && dataFullyLoaded && screen?.toLowerCase() === 'view') {
			if (leaseDetailsShowAllRef.current?.loadData) {
				leaseDetailsShowAllRef.current.loadData();
			}
		}
	};
	useEffect(() => {
		if (dataFullyLoaded && screen?.toLowerCase() === 'view') {
			actionButtonsRef.current.handleDataLoading();
		}
	}, [dataFullyLoaded]);

	// Only show loading if no cached data is available
	const showSpinner = screen?.toLowerCase() === 'view' ? isViewLoading && !initialCachedData : isCreatLoading;

	const tabItem = [
		{
			key: '1',
			label: 'Lease Details',
			children: (
				<>
					<CardAccordion
						title="Basic Information"
						darkTitle={true}
						sx={{
							mb: 2,
						}}
						customHeaderSX={{
							backgroundColor: '#e1f0fb !important',
						}}
						typographySX={{ fontSize: '16px !important' }}
					>
						<GeneralLeaseInformation screen={screen} vendorList={lynFormProperties?.vendorList} />
					</CardAccordion>

					<FinancialTermsConditions screen={screen} dataFullyLoaded={dataFullyLoaded} />
					<CardAccordion
						title="IFRS - 16 Specific Fields"
						darkTitle={true}
						sx={{
							mb: 2,
						}}
						customHeaderSX={{
							backgroundColor: '#e1f0fb !important',
						}}
						typographySX={{ fontSize: '16px !important' }}
					>
						<IFRS16FieldsModifications screen={screen} rowIndex={rowIndex} />
					</CardAccordion>
					<ActionButtons
						screen={screen}
						viewData={singleLeaseData}
						selectHistory={setSelectHistory}
						dataFullyLoaded={dataFullyLoaded}
						ref={actionButtonsRef}
						handleCreation={handleSubmit}
						hasGlAssigned={hasGlAssigned}
						hasCCAssigned={hasCCAssigned}
					/>
				</>
			) || <></>,
		},
		{
			key: '2',
			label: 'Lease Schedule',
			children: (
				<>
					<LeaseSchedule
						screen={screen}
						viewData={singleLeaseData}
						dataFullyLoaded={dataFullyLoaded}
						ref={leaseScheduleRef}
						hasGlAssigned={hasGlAssigned}
						hasCCAssigned={hasCCAssigned}
						key={`lease-schedule-${singleLeaseData?.data?.leaseId || 'new'}-${tabInstanceId}`}
					/>
				</>
			),
		},
		...(screen?.toLowerCase() === 'view'
			? [
					{
						key: '3',
						label: 'Modification History',
						children: (
							<>
								<LeaseHistory viewData={singleLeaseData} selectHistory={setSelectHistory} />
							</>
						),
					},
				]
			: []),
		...(screen?.toLowerCase() !== 'create'
			? [
					{
						key: screen?.toLowerCase() === 'view' ? '4' : '3',
						label: 'Accounts Assignment',
						children: (
							<>
								<AccountingInformation screen={screen} identityId={singleLeaseData?._id} />
							</>
						),
					},
				]
			: []),
		...(screen?.toLowerCase() === 'view'
			? [
					{
						key: screen?.toLowerCase() === 'view' ? '5' : '',
						label: 'General Ledgers',
						children: (
							<>
								{/*<CardAccordion*/}
								{/*	title="General Ledger View"*/}
								{/*	darkTitle={true}*/}
								{/*	sx={{*/}
								{/*		mt: 2,*/}
								{/*		mb: 2,*/}
								{/*	}}*/}
								{/*	customHeaderSX={{*/}
								{/*		backgroundColor: '#e1f0fb !important',*/}
								{/*		p: '10px',*/}
								{/*		fontSize: '16px !important',*/}
								{/*	}}*/}
								{/*	typographySX={{ fontSize: '16px !important' }}*/}
								{/*>*/}
								<LeaseDetailsShowAll ref={leaseDetailsShowAllRef} />
								{/*</CardAccordion>*/}
							</>
						),
					},
				]
			: []),
		...(screen?.toLowerCase() !== 'create' && statusData?.agreementFiles?.length > 0
			? [
					{
						key: screen?.toLowerCase() === 'view' ? '6' : '4',
						label: 'Agreements',
						children: <AgreementFiles screen={screen} />,
					},
				]
			: []),
		...(screen?.toLowerCase() !== 'view'
			? [
					{
						key: screen?.toLowerCase() === 'view' ? '7' : '5',
						label: 'Bulk Upload',
						children: (
							<>
								<LeaseBulkUpload vendorList={lynFormProperties?.vendorList} />
							</>
						),
					},
				]
			: []),
	];

	return (
		<Box>
			<Spin spinning={showSpinner} style={{ maxHeight: '100%' }}>
				{/* <Loader loading={showSpinner}> */}
				<LeasePageHeader
					createBtn={false}
					tabsItem={tabItem}
					selectedTab={selectedTab}
					selectTabHandler={selectTabHandler}
					image={<SolutionCatalogIcon color="#fff" />}
					title={screen === 'CREATE' ? 'Create Lease Record' : 'View Lease Record'}
					secondaryTitle={screen === 'CREATE' ? '' : `Lease ID: ${statusData?.leaseId || ''}`}
				/>

				<MainCard sx={{ overflow: 'visible' }}>
					<Form
						form={form}
						layout="vertical"
						onFinish={handleSubmit}
						autoComplete="off"
						requiredMark={false}
						initialValues={initialFormValues}
						// preserve={true}
					>
						<AntdValuePreview form={form} show={true} />
						{/*<Box sx={{ mt: 2 }}>*/}
						{/*	{tabItem?.map((item, index) => (*/}
						{/*		<TabPanel key={index} value={selectedTab} index={index}>*/}
						{/*			<Box sx={{ mt: 2 }}>{tabItem[selectedTab]?.children}</Box>*/}
						{/*		</TabPanel>*/}
						{/*	))}*/}
						{/*</Box>*/}
						<Box sx={{ mt: 2 }}>
							{tabItem?.map((item, index) => (
								<Box
									key={index}
									style={{
										display: selectedTab === index ? 'block' : 'none',
									}}
								>
									{item.children}
								</Box>
							))}
						</Box>
					</Form>
				</MainCard>

				{formState?.showFormSubmitModal && (
					<ComptrollerConfirmModal
						showModal={formState?.showFormSubmitModal}
						modalData={formState?.modalData}
						setShowModal={setShowFormSubmitModal}
						handleSubmit={handleModalSubmit}
					/>
				)}
				{selectHistory && (
					<IdentityCaseActivityModal
						title={state?.processName}
						setSelectHistory={setSelectHistory}
						selectItem={selectHistory}
						processCode={singleLeaseData?.processCode}
						processVersion={singleLeaseData?.parkProcessVersion}
					/>
				)}
			</Spin>
			{/* </Loader> */}
		</Box>
	);
};

export default Create;

export const useControlData = () => {
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const {
		data: getVendorList,
		isLoading: isVendorLoading,
		isError: isVendorError,
	} = useGetQueryV3DeltaQuery(
		{
			companyCode,
			fieldCodes: ['companyCode'],
			fieldValues: [companyCode],
			name: 'getVendorData',
		},
		{
			skip: !companyCode,
		}
	);

	const lynFormProperties = useMemo(
		() => ({
			vendorList:
				getVendorList?.results?.map((item) => ({
					label: item?.vendorName,
					value: item?._id,
					code: item?.vendorCode,
				})) ?? [],
		}),
		[getVendorList]
	);

	return {
		lynFormProperties,
		isLoading: isVendorLoading,
		isError: isVendorError,
	};
};